/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditMentionsAuditMentionsDateSchedulesListQueryResponse, AuditMentionsAuditMentionsDateSchedulesListQueryParams } from "../models/AuditMentionsAuditMentionsDateSchedulesList";

export function getAuditMentionsAuditMentionsDateSchedulesListUrl() {
  const res = { method: 'GET', url: `/audit-mentions/v1/date-schedules` as const }
  return res
}

/**
 * @description Returns mention date schedules for a station and date.
 * @summary List mention date schedules
 * {@link /audit-mentions/v1/date-schedules}
 */
export async function auditMentionsAuditMentionsDateSchedulesList(params: AuditMentionsAuditMentionsDateSchedulesListQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditMentionsAuditMentionsDateSchedulesListQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAuditMentionsAuditMentionsDateSchedulesListUrl().url.toString(), params, ... requestConfig })
  return res.data
}